export const tableData = {
  tHead: [
    {
      title: '序号',
      slot:'index',
    },
    {
      key: 'filename',
      dataIndex: 'filename',
      title: '文件名称',
    },
    {
      slot:'yl',
      title: '预览',
    },
    {
      title: '下载',
      slot:'download',
    },
    {
      title: '删除',
      slot:'delete',
    },
  ],
  tBody: [],
  tPage: {
    total: 0,
    page: 1,
    pageSize: 10
  },
};
